module.exports = __webpack_public_path__ + "img/tran_3kl.b3fb32a3.jpg";